import userApi from '@/api/user.api'
import { getItemsById } from '@/tools/functions'

export const userService = (function () {
  'use strict'

  /**
   * Devuelve los datos para la tabla del ABM de Usuarios
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   * @param {*} enterpriseLess
   */
  async function findAll(pageSize, pageNumber, headers = false, enterpriseIds, enterpriseLess) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await userApi.findAll(pageSize, pageNumber, headers, enterpriseIds, enterpriseLess)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await userApi.findAll(undefined, undefined, headers, enterpriseIds, enterpriseLess)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        headers: [],
        data: []
      }
    }
  }

  /**
   * Devuelve el total de Usuarios de la collection para el paginador de la tabla del ABM
   * @param {*} enterpriseIds
   * @param {*} enterpriseLess
   */
  async function getTotal(enterpriseIds, enterpriseLess) {
    try {
      const response = await userApi.getTotal(enterpriseIds, enterpriseLess)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve un usuario con el id enviado como parámetro
   * @param {*} userId
   */
  async function getUser(userId) {
    try {
        const response = await userApi.getUser(userId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Devuelve los datos de un usuario para actalización
   * @param {*} userId
   */
  async function getUserForABM(userId) {
    try {
        const response = await userApi.getUserForABM(userId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Para validar el nombre de usuario
   * Devuelve true si ya está asignado a un usuario
   * @param {*} username
   */
  async function validateUsername(username) {
    try {
      if (username) {
        const response = await userApi.validateUsername(username)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para eliminar un user
   */
  async function deleteOne(id) {
    const response = await userApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    const response = await userApi.deleteMany(ids)
    return response.data
  }

  /**
   * Crea una nuevo grupo en la collection y envía un correo electrónico de
   * bienvenida si se eligió dicha acción desde el ABM
   * @param {*} userDto
   * @param {*} sendEmail
   */
  async function create(userDto, sendEmail = false) {
    const response = await userApi.create(userDto, sendEmail)
    return response.data
  }

  /**
   *  Actualiza un grupo existente en la collection
   * @param {*} user
   */
  async function update(user) {
    const response = await userApi.update(user)
    return response.data
  }

  /**
   * Deshabilitar usuarios
   * @param {*} ids
   */
  async function disable(ids) {
    const response = await userApi.disable(ids)
    return response.data
  }

  /**
   * A partir de la estructura anidada de empresas -> grupos -> cosas y los arreglos de empresas, grupos y cosas
   * que tienen visibilidad el usuario, obtener un arreglo de los nodos que deben seleccionarse en
   * el treeview del dialog del ABM User
   * @param {*} thingNested
   * @param {*} enterpriseIds
   * @param {*} groupIds
   * @param {*} thingIds
   */
  function getSelectedData(thingNested, enterpriseIds, groupIds, thingIds) {
    let result = []
    // cosas
    getItemsById(thingNested, thingIds, result)
    // empresas
    getItemsById(thingNested, enterpriseIds, result)
    // grupos
    getItemsById(thingNested, groupIds, result)
    return result
  }

  /**
   * A partir del arreglo de cosas seleccionadas, obtener los ids de cosas, grupos y empresas
   * @param {*} selectedData
   */
  function getThingsGroupsEnterprises(selectedData) {
    const result = { userThings: [], userEnterprises: [], userGroups: [] }

    selectedData.forEach(node => {
      switch(node.nodeType) {
        case 'THING':
          result.userThings.push(node.id)
          break;
        case 'ENTERPRISE':
          result.userEnterprises.push(node.id)
          break;
        case 'GROUP':
          result.userGroups.push(node.id)
          break;
        default:
          console.error('No corresponde a una cosa, grupo o empresa')
      }
    })

    return result
  }

  /**
   * A partir del arreglo de cosas, grupos o empresas seleccionados, obtener los ids de aquellos que no estén
   * deshabilitados, es decir, sólo los que el user pudo haber modificado
   * @param {*} selectedData
   */
  function getModifiedIds(selectedData) {
    const enabledNodes = selectedData.filter(node => !node.disabled);
    return enabledNodes.map(node => (node.id))
  }

  /**
   * Arreglo de usuarios para utilizar en los selectores
   */
  async function getAllForSelector () {
    try {
      const response = await userApi.getAllForSelector()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Obtiene la configuración de autoUpdateEnterprises para un usuario
   * @param {*} userId
   */
  async function getAutoUpdateEnterprises(userId) {
    try {
      const response = await userApi.getAutoUpdateEnterprises(userId)
      // El endpoint devuelve un objeto con la propiedad autoUpdateEnterprises
      return response.data.autoUpdateEnterprises
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Establece la configuración de autoUpdateEnterprises para un usuario
   * @param {*} userId
   * @param {*} enabled
   */
  async function setAutoUpdateEnterprises(userId, enabled) {
    try {
      const response = await userApi.setAutoUpdateEnterprises(userId, enabled)
      return response.data
    } catch (exception) {
      console.log(exception)
      throw exception
    }
  }

  return {
    findAll,
    getTotal,
    getUser,
    validateUsername,
    deleteOne,
    deleteMany,
    create,
    update,
    disable,
    getUserForABM,
    getSelectedData,
    getThingsGroupsEnterprises,
    getModifiedIds,
    getAllForSelector,
    getAutoUpdateEnterprises,
    setAutoUpdateEnterprises,
  }
})()
